var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_404"},[_c('div',{staticClass:"tip"},[_vm._v("抱歉，您访问的页面不存在！")]),_c('div',{staticClass:"opt-area"},[_c('div',{staticClass:"go-login",on:{"click":_vm.handleRefresh}},[_vm._v("请刷新重试")]),_c('div',{staticClass:"info-txt"},[_vm._v("或者")]),_c('div',{staticClass:"go-login",on:{"click":_vm.handleLogin}},[_vm._v("去登陆")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }